module.exports = __webpack_public_path__ + "img/w3_maximize_dark.08e1d308.png";